<template>
<div class="np-alert np-alert-ani np-alert-dialog" v-if="showAlert || showContent"
	@mouseover="mouseover"
	:class="alertClass"
	:data-alerttipsid="createId()" 	
	:style="style"	
	ref="alertDialog"	
>	
	<div class="np-alert-dialog_content fc-gnr fs-xs" v-if="!isContentRender()" v-html="opts.content"></div>	
	<alert-content v-else></alert-content>
</div>
</template>
<script>
let count = 0,_this;
export default {
	props:["options","show","event","onClose"],
	created: function(){
		this.opts = this.options || {};	
		_this = this;
	},
	mounted: function(){
		var _this = this;
			setTimeout(()=>{
				_this.showAlert = _this.show;	
				if(this.opts.skin){
				this.alertClass.push(this.opts.skin);
				}
				//内聯樣式
				if(this.opts.style instanceof Object){
					for(let k in this.opts.style){
						this.style[k] =  this.opts.style[k];
					}
				}
				if(typeof this.opts.style === "string"){
					this.style =  this.opts.style;
				}
				setTimeout(()=>{
					_this.create();
				})
				
			},100);
	},	
	data: function(){
		return {
			showContent:true,
			showAlert: false,
			opts: null,
			style: {},
			alertClass:[]
		}
	},
	methods:{
		mouseover(){
			this.showContent = true;
			console.log(this.showContent)
		},
		isContentRender(){
			if(typeof this.opts.content === "function"){
				return true;
			}
		},
		createId(){
			return  "npalert" + count++;
		},		
		create: function(){			
			if(!this.event){
				return console.log("必須傳入事件對象！");
			}
			//支持事件列表
			/* 
			1，
			*/
			if(this.event.type === "mouseover"){
				this.setPosition();
			}
			if(this.event.type === "mouseleave"){
				let items = this.$tools.getElementByattr("div","data-alerttipsid",/^npalert/);
				for(let i = 0; i<items.length;i++){		
					//console.log("A")
					items[i].remove();
				}
			}
			
		},
		setPosition(){
			var element = this.event.target;
			var offset = this.$tools.getOffset(element);
			var dialogBox = this.$refs.alertDialog;
			var left = 0,top = 0,marginLeft = 0;
			var letArrwidth = 10;
			switch(this.opts.position){
				case "left":
					top = offset.top + element.offsetHeight/2 - dialogBox.offsetHeight/2;
					left = offset.left -  dialogBox.offsetWidth - letArrwidth;
					this.alertClass.push("lt")
				break;
				case "right":
					top = offset.top + element.offsetHeight/2 - dialogBox.offsetHeight/2;
					left = offset.left + element.offsetWidth + letArrwidth;
					this.alertClass.push("gt")
				break;
				case "top":
					top = offset.top - dialogBox.offsetHeight - letArrwidth;
					left = offset.left + element.offsetWidth/2 ;
					this.alertClass.push("tt")
				break;
				default:
					top = offset.top + element.offsetHeight + letArrwidth;
					left = offset.left + element.offsetWidth/2;
					this.alertClass.push("bt")
			}			
			//邊界檢測
				
			//賦值
				dialogBox.style.top = top + "px";
				dialogBox.style.left = left + "px";
				if(marginLeft){
					dialogBox.style.marginLeft = marginLeft + "px";
				}
		},		
		close:function(){
			//let _this = this;
				//_this.showClass = false;
				//removestyle			
			if(typeof _this.onClose === "function"){
				_this.onClose();
			}
			/* setTimeout(function(){
				_this.showAlert = false;
			},150); */
		}/* ,
		components:{
			//'alert-content':content
		} */
	},
	components:{
		'alert-content':{
			render(h){				
				if(typeof _this.opts.content === "function"){
					return _this.opts.content(h,_this);
				}
				//
			}
		}
	}
}	
</script>
<style lang="scss">
$alert-hover-border-color:#ddd;
/* $dialog-minwidth: 100px;
$dialog-minheight: 60px; */
$dialog-rs: 3px;
$dialog-padding: 15px;
.np-alert-ani {
	@include  trans-animate-easeout();
}
.np-alert {
	//np-alert-hover
	&-dialog {
		position: absolute;	
		z-index: 9999;
		border: 1px solid $alert-hover-border-color;
		border-radius: $dialog-rs;
		/* min-width: $dialog-minwidth;
		min-height: $dialog-minheight; */
		padding: $dialog-padding;
		box-sizing: border-box;
		background-color: #fff;
		box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.05);
		&::after {
			position: absolute;
			content: "";	
			width: 10px;
			height: 10px;
			border-left: 1px solid $alert-hover-border-color;
			border-top: 1px solid $alert-hover-border-color;
			border-radius: 3px 0 0 0;			
			background-color: #fff;	
		}
		&.lt,&.gt {			
			&::after {									
				top: 50%;
				margin-top: -5px;
			}
		}
		&.lt {
			&::after {
				@include transform-rotate(135deg);	
				right: -7px;
			}
		}
		&.gt {
			&::after {
				@include transform-rotate(-45deg);				
				left: -7px;
			}
		}
		&.tt,&.bt {
			@include transform(translateX(-50%));
			&::after {	
				margin-left: -5px;
				left: 50%;
			}
		}
		&.tt {
			&::after {
				bottom: -7px;
				@include transform-rotate(-135deg);		
			}
		}
		&.bt {
			&::after {									
				top: -7px;
				@include transform-rotate(45deg);	
			}
		}
		//np-alert-dialog_content
		&_content {
			//max-height: 230px;
			overflow: auto;
			word-break: break-word;
		}
	}
}
</style>